<template>
  <div id="weight-list-container">
    <div class="row">
      <div class="col-sm">
        <select
          class="form-control"
          v-model="store.state.weightView.selectedSortingOption"
          v-on:change="sort"
        >
          <option
            v-for="sortingOption in store.state.weightView.sortingOptions"
            v-bind:key="sortingOption"
            v-bind:value="sortingOption"
          >{{ sortingOption }}</option>
        </select>
      </div>
      <div class="col-sm"></div>
    </div>
    <div class="mb-3 hidden-md-up"></div>
    <div>
      <weight-card
        v-for="measurement in measurements"
        v-bind:key="measurement.id"
        :measurement="measurement"
      />
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import WeightCard from "@/components/WeightCard.vue";

export default {
  name: "WeightList",
  components: {
    WeightCard
  },
  data: function() {
    return {
      store: store,
      measurements: []
    };
  },
  computed: {
    selectedSortingOption: function() {
      return this.store.state.weightView.selectedSortingOption;
    }
  },
  created: function() {

  },
  mounted: function() {
    this.measurements = [...store.state.weighingResults];
    this.sort();
  },
  methods: {
    sortOldestFirst: function() {
      this.measurements.sort(this.store.compareByDatetimeOldestFirst);
    },
    sortNewestFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return self.store.compareByDatetimeOldestFirst(a, b) * -1;
      });
    },
    sortHighestFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return self.store.compareByMeasurementHighestFirst(a.weight, b.weight);
      });
    },
    sortLowestFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return (
          self.store.compareByMeasurementHighestFirst(a.weight, b.weight) * -1
        );
      });
    },
    sort: function() {
      if (this.selectedSortingOption == "Newest first") {
        this.sortNewestFirst();
      } else if (this.selectedSortingOption == "Oldest first") {
        this.sortOldestFirst();
      } else if (
        this.selectedSortingOption == "Highest weight first"
      ) {
        this.sortHighestFirst();
      } else if (
        this.selectedSortingOption == "Lowest weight first"
      ) {
        this.sortLowestFirst();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#weight-list-container {
  margin-top: 1rem;
}
</style>
